module.exports = __webpack_public_path__ + "public/Icons/earnIconDashboard.png?d0c2bb89";